import { useTranslation } from 'react-i18next';

/**
 * Utility function to simplify translation in components.
 * @param prefix (Optional) The prefix for the translation keys.
 * @returns A function that appends the prefix to each key and calls the `t` function.
 * If no prefix is provided, it directly uses the key.
 */
export const useTranslate = (prefix?: string) => {
    const { t } = useTranslation();

    return (key: string) => {
        return prefix ? t(`modular_donation_form.${prefix}.${key}`) : t(`modular_donation_form.${key}`);
    };
};
